import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, openFile, byteSize } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './device.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import DoNotShowInProduction from 'app/shared/components/do-not-show-in-production/do-not-show-in-production.component';

export const DeviceDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const deviceEntity = useAppSelector(state => state.device.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="deviceDetailsHeading">
          <Translate contentKey="fleetSenseApp.device.detail.title">Device</Translate>
        </h2>
        <dl className="jh-entity-details">
          <DoNotShowInProduction>
            <dt>
              <span id="id">
                <Translate contentKey="global.field.id">ID</Translate>
              </span>
            </dt>
            <dd>{deviceEntity.id}</dd>
          </DoNotShowInProduction>
          <dt>
            <span id="deviceType">
              <Translate contentKey="fleetSenseApp.device.deviceType">Device Type</Translate>
            </span>
          </dt>
          <dd>{deviceEntity.deviceType}</dd>
          <dt>
            <span id="manufacturer">
              <Translate contentKey="fleetSenseApp.device.manufacturer">Manufacturer</Translate>
            </span>
          </dt>
          <dd>{deviceEntity.manufacturer}</dd>
          <dt>
            <span id="model">
              <Translate contentKey="fleetSenseApp.device.model">Model</Translate>
            </span>
          </dt>
          <dd>{deviceEntity.model}</dd>
          <dt>
            <span id="image">
              <Translate contentKey="fleetSenseApp.device.image">Image</Translate>
            </span>
          </dt>
          <dd>
            {deviceEntity.image ? (
              <div>
                {deviceEntity.imageContentType ? (
                  <a onClick={openFile(deviceEntity.imageContentType, deviceEntity.image)}>
                    <img src={`data:${deviceEntity.imageContentType};base64,${deviceEntity.image}`} style={{ maxHeight: '30px' }} />
                  </a>
                ) : null}
                <span>
                  {deviceEntity.imageContentType}, {byteSize(deviceEntity.image)}
                </span>
              </div>
            ) : null}
          </dd>
          <dt>
            <span id="objectKey">
              <Translate contentKey="fleetSenseApp.device.objectKey">Object Key</Translate>
            </span>
          </dt>
          <dd>{deviceEntity.objectKey}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="fleetSenseApp.device.description">Description</Translate>
            </span>
          </dt>
          <dd>{deviceEntity.description}</dd>
        </dl>
        <Button tag={Link} to="/device" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/device/${deviceEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DeviceDetail;
